<template>
    <package-booking-page-layout v-if="loaded" :search-request="searchRequest" :offer="basketItem.hotel">
        <template v-slot:breadcrumbs>
            <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="refreshExpiredOffers" />
            <package-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:tourists="{tourists, index, disabled, personSelected, isSavingWithoutDetails, formRefs}">
            <flight-tourist-form
                :ref="el => formRefs.push(el)"
                v-model="tourists[index]"
                :disabled="disabled"
                :index="index"
                :offer="basketItem.flight"
                is-package
                :hide-index="tourists.length === 1"
                :start-date="startDate"
                :data-cy="`tourist-${index}`"
                :disable-required-rule="isSavingWithoutDetails"
                @person-selected="personSelected"
            />
        </template>
        <template v-slot:sidebar="{bookingKey}">
            <selected-offers
                :direction="'column'"
                :bookable="false"
                :changable="!bookingKey"
                :hotel="basketItem.hotel"
                :room="basketItem.room"
                :flight="basketItem.flight"
                :price="basketItem.price"
                :search-request="searchRequest"
                :total-order-price="basketItem.totalPrice"
            />
        </template>
    </package-booking-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import PackageBookingPageLayout from '~/components/packages/booking/PackageBookingPageLayout.vue'
    import FlightTouristForm from '~src/components/booking/forms/flightTouristForm.src'
    import SelectedOffers from '~/components/packages/search/SelectedOffers.vue'
    import PackageBreadcrumbs from '~/components/packages/PackageBreadcrumbs.vue'
    import {PackagePageMixin} from '@/components/packages/mixins/PackagePageMixin.vue'
    import ExpiredOffersSnackbar from '@/components/search/ExpiredOffersSnackbar.vue'
    import {UTCToDate} from '@/utils/helpers'

    @Component({
        components: {
            ExpiredOffersSnackbar,
            PackageBookingPageLayout,
            FlightTouristForm,
            SelectedOffers,
            PackageBreadcrumbs,
        },
    })
    export class PackageBookingPage extends mixins(PackagePageMixin) {
        loaded = false
        formRefs = []

        async mounted() {
            await this.$store.restored
            await Promise.all([
                this.loadRuntimeData(),
                runtimeStore.loadTouristBookingFields({offerKey: this.basketItem.flight.offerKey}),
            ])
            this.loaded = true
        }

        isOffersExpired() {
            return (
                this.$dateFns.isAfter(
                    new Date(),
                    UTCToDate(this.$dateFns.parseISO(this.basketItem.flight.expirationTime))
                ) &&
                !runtimeStore.bookingActive &&
                !packagesStore.prepareBookResponse.bookingKey
            )
        }

        refreshExpiredOffers() {
            this.$router.push(packagesRuntimeStore.searchPageLink(this.searchRequest))
        }

        get basketItem() {
            return packagesStore.basketItem(this.$route.query.offerKey)
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get startDate() {
            return this.searchRequest.startDate
        }
    }

    export default PackageBookingPage
</script>
